import { memo, useState } from 'react';
import cn from 'classnames';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Form from 'antd/lib/form/Form';

import useModal from 'hooks/useModal';
import WithPrompt from 'hocs/WithPrompt';
import { SettingsTabPaths } from 'components/Settings/constants';
import { EModalsNames } from 'modals/constants';

const WithSettingsForm = ({ form, initialValues, onSubmit, rootPath, children }: any) => {
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [isTouched, setIsTouched] = useState<boolean>(false);
  const setModal = useModal();

  const handleSubmit = async() => {
    setIsUpdating(true);
    await onSubmit();
    setIsTouched(false);
    setIsUpdating(false);
  };

  return (
    <WithPrompt
      rootPath={rootPath}
      isTouched={isTouched}
      setIsTouched={setIsTouched}
      onResetFields={form.resetFields}
    >
      <Form
        form={form}
        layout="vertical"
        validateTrigger="onSubmit"
        initialValues={initialValues}
        onFinish={handleSubmit}
        onFieldsChange={() => setIsTouched(true)}
      >
        <div className="form-content overflow-y-scroll overflow-x-hidden">{children}</div>
        <div>
          <Divider className="mt-0 mb-4" />
          <div className="flex items-center justify-between">
            <Button
              danger
              type="link"
              size="large"
              className={cn({ hidden: rootPath !== SettingsTabPaths.AccountSupplier })}
              onClick={() => setModal({ modalName: EModalsNames.DeleteAccount })}
            >
              Delete Account
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="block ml-auto mr-11"
              disabled={!isTouched}
              loading={isUpdating}
            >
              Save
            </Button>
          </div>
        </div>
      </Form>
    </WithPrompt>
  );
};

export default memo(WithSettingsForm);
